module.exports = __webpack_public_path__ + "files/8e61c42460096221c272e4ed07fca02b.png";